import React, { FC } from 'react';
import { Badge } from 'rsuite';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar, faCreditCard, faDollarSign, faLink, faCoins, faShoppingCart, faCircleExclamation, faIdCard } from '@fortawesome/free-solid-svg-icons';
import { WhisperComponent } from '../../../developers/page-components/WhisperComponent';
import clsx from 'clsx';
import { IPotentialMatch } from '../../../../store/tables/disputes/disputes-data';

const iconsArray = [
  {
    title: '',
    matchName: 'error',
    icon: faCircleExclamation,
  },
  {
    title: 'Arn',
    matchName: 'arn',
    icon: faLink,
  },
  {
    title: 'Order id',
    matchName: 'orderId',
    icon: faShoppingCart,
  },
  {
    title: 'Transaction id',
    matchName: 'transactionId',
    icon: faLink,
  },
  {
    title: 'External reference id',
    matchName: 'externalReferenceId',
    icon: faLink,
  },
  {
    title: 'Bin / Last4',
    matchName: 'bin',
    icon: faCreditCard,
  },
  // {
  //   title: 'Last4',
  //   matchName: 'last4',
  //   icon: faCreditCard,
  // },
  {
    title: 'Amount',
    matchName: 'amount',
    icon: faCoins,
  },
  {
    title: 'Date',
    matchName: 'date',
    icon: faCalendar,
  },
  {
    title: 'Currency',
    matchName: 'currency',
    icon: faDollarSign,
  },
  {
    title: 'Authorization Id',
    matchName: 'authorizationId',
    icon: faIdCard,
  },
];

interface Props {
  potentialMatches: IPotentialMatch[];
  matchError: string;
  allowReconciliation: boolean;
}
export const PotentialMatchColumn: FC<Props> = ({ potentialMatches, matchError, allowReconciliation }) => {
  const data: IPotentialMatch = potentialMatches?.[0] || null;

  const matchedIcons = [
    ...(matchError
      ? iconsArray
        .filter(icon => icon.matchName === 'error')
        .map(icon => ({ ...icon, title: matchError })) // Set error text in title
      : []),
    ...iconsArray.filter(icon =>
      data?.matchedFields?.some((el: string) => el?.toLowerCase() === icon.matchName?.toLowerCase())
    )
  ];

  const matchColor = data?.value >= 80 && potentialMatches?.length === 1 && !matchError && allowReconciliation
    ? 'text-black'
    : 'text-muted';

  return (
    <>
      {
        potentialMatches?.length ? <Badge className="" content={potentialMatches?.length} /> : '-'
      }

      {
        data?.value && <div className={clsx('ms-2 fs-8', matchColor )}>{data?.value}%</div>
      }

      {
        matchedIcons.map(({ matchName, icon, title }) => (
          <span className="ms-2" key={matchName}>
            <WhisperComponent
              isTooltip
              whisperText={title}
              placement={'top'}
              mainText={
                <FontAwesomeIcon
                  icon={icon}
                  width={12}
                  className={clsx( matchName === 'error' ? 'text-danger' : matchColor)}
                />
              }
            />
          </span>
        ))
      }

    </>
  );
};
